import { render, staticRenderFns } from "./review-result.dialog.vue?vue&type=template&id=67969ad3&scoped=true"
import script from "./review-result.dialog.vue?vue&type=script&lang=js"
export * from "./review-result.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67969ad3",
  null
  
)

export default component.exports